import { types, API_URL } from './types';
import { axiosApi } from './index';

export const exportLeadsCsv = () => {
  const url = `${API_URL}/api/v1/lead/export`;
  return axiosApi.get(url, {
    responseType: 'blob',
    validateStatus: false,
  });
};

export const getLeads = () => {
  let url = `${API_URL}/api/v1/lead`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetLeads(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetLeads(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        if (error.response) {
          // Server responded with error status
          const status = error.response.status;
          const errorData = error.response.data;
          if (status === 401) {
            outputData['message'] =
              'No tienes permisos para acceder a los leads. Verifica tu rol de usuario.';
          } else if (status === 403) {
            outputData['message'] = 'Acceso denegado a los leads';
          } else {
            outputData['message'] =
              errorData?.message || 'Error del servidor al cargar leads';
          }
        } else if (error.request) {
          // Request was made but no response
          outputData['message'] = 'Error de conexión con el servidor';
        } else {
          // Something else happened
          outputData['message'] = 'Error inesperado al cargar los leads';
        }
        dispatch(setGetLeads(outputData));
      });
  };
};

export const setGetLeads = (data) => ({
  type: types.lmGetLeads,
  payload: data,
});

export const getLeadItems = (search = '') => {
  let url = `${API_URL}/api/v1/lead/item`;
  if (search !== '') {
    url += `?search=${search}`;
  }
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetLeadItems(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetLeadItems(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetLeadItems({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetLeadItems = (data) => ({
  type: types.lmGetLeadItems,
  payload: data,
});

export const createLead = (leadData) => {
  const role = localStorage.getItem('role');
  const userEmail = localStorage.getItem('email');

  // Si es vendedor, agregar información de asignación
  if (role === 'vendedor') {
    leadData.assignedTo = userEmail;
    leadData.state = 'assigned';
  }

  let url = `${API_URL}/api/v1/lead/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, leadData, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateLead(outputData));
        } else {
          outputData['status'] = data.status || 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setCreateLead(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setCreateLead({ status: 'danger', error: true, message }));
        });
  };
};

export const setCreateLead = (data) => ({
  type: types.lmCreateLead,
  payload: data,
});

export const getLeadUsers = () => {
  let url = `${API_URL}/api/v1/lead/user`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetLeadUsers(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetLeadUsers(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetLeadUsers({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetLeadUsers = (data) => ({
  type: types.lmGetLeadUsers,
  payload: data,
});

export const updateLead = (leadId, leadInfo) => {
  const url = `${API_URL}/api/v1/lead/edit/${leadId}`;
  return (dispatch) => {
    let outputData = {};
    return axiosApi
      .put(url, leadInfo, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateLead(outputData));
        } else {
          outputData['status'] = data.status || 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setUpdateLead(outputData));
        }
        return data;
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setUpdateLead({ status: 'danger', error: true, message }));
        });
  };
};

export const setUpdateLead = (data) => ({
  type: types.lmUpdateLead,
  payload: data,
});

export const getLeadById = (leadId) => {
  let url = `${API_URL}/api/v1/lead/detail/${leadId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetLeadById(outputData));
      } else {
        outputData['status'] = data.status || 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetLeadById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetLeadById({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetLeadById = (data) => ({
  type: types.lmGetLeadById,
  payload: data,
});

export const updateLeadOrder = (leadId, state, order) => {
  let url = `${API_URL}/api/v1/lead/edit/${leadId}`;
  return (dispatch) => {
    let outputData = {};

    // Create a minimal payload that only updates the order within the existing state structure
    const leadInfo = {
      state: state,
      order: order,
      // Add a flag to indicate this is just an order update
      orderOnly: true,
    };

    axiosApi
      .put(url, leadInfo, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          console.error(
            `❌ Failed to update lead ${leadId} order:`,
            data.message,
          );
          dispatch(setUpdateLeadOrder(outputData));
        } else {
          outputData['status'] = data.status || 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;

          dispatch(setUpdateLeadOrder(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setUpdateLeadOrder({ status: 'danger', error: true, message }));
        });
  };
};

export const setUpdateLeadOrder = (data) => ({
  type: types.lmUpdateLeadOrder,
  payload: data,
});
